var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebpack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8ed6fb",
    d: "M117.29 98.1 66.24 127v-22.51L98 87l19.29 11.1Zm3.5-3.16V34.55l-18.68 10.8v38.81l18.67 10.77ZM10.71 98.1l51 28.88v-22.49L29.94 87Zm-3.5-3.16V34.55l18.68 10.8v38.81Zm2.19-64.3L61.76 1v21.76L28.21 41.21l-.27.15Zm109.18 0L66.24 1v21.76L99.79 41.2l.27.15 18.54-10.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c78c0",
    d: "M61.76 99.37 30.37 82.1V47.92L61.76 66Zm4.48 0 31.39-17.25v-34.2L66.24 66ZM32.5 44 64 26.66 95.5 44 64 62.16 32.5 44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpack);
export default __webpack_public_path__ + "static/media/webpack.6930555b6498e9967f39b253114f3a4e.svg";
export { ForwardRef as ReactComponent };